import { useCallback } from "react";

import { useAuthUser } from "@features/auth";

import { realmPathUrl } from "./helpers";

export const useRealmUrl = () => {
  const { realm } = useAuthUser();
  return useCallback(
    (path: `/${string}`): `/${string}` => {
      return realmPathUrl(realm, path);
    },
    [realm]
  );
};
